import moment from "moment";
import { Icon } from "@iconify/react";
import { Button, Dialog } from "@mui/material";
import "./ConfirmBroadcastDialog.css";
import "../Components/Components.css";

const ConfirmBroadcastDialog = ({
  contactAmount,
  createSchedule,
  isOpen,
  schedule,
  isSending,
  send,
  setIsConfirmBroadcastDialogShown,
}) => {
  const handleClose = () => {
    setIsConfirmBroadcastDialogShown(false);
  };

  function renderContent() {
    /* if (schedule) { */
    if (isSending) {
      return <p>Creating broadcast schedule...</p>;
    } else {
      return (
        <>
          <p>
            {schedule
              ? "You are about to create a broadcast schedule to"
              : "You are about to send a broadcast message to"}{" "}
            <span>{contactAmount} Contacts</span>
          </p>

          {schedule && (
            <p>
              on{" "}
              <span>
                {moment(schedule).format("dddd, D MMMM YYYY [at] HH:mm")}
              </span>
            </p>
          )}

          <p>Are you sure?</p>
        </>
      );
    }
    /* } else {
      if (isSending) {
        return <p>Sending broadcast message...</p>;
      } else {
        return (
          <>
            <p>
              You are about to Broadcast to{" "}
              <span>{contactAmount} Contacts</span>
            </p>

            <p>Are you sure?</p>
          </>
        );
      }
    } */
  }

  return (
    <Dialog
      open={isOpen}
      className="dialog confirm-broadcast-dialog"
      fullWidth
      maxWidth="sm"
      scroll="paper"
      onClose={handleClose}
    >
      <header>
        <Icon height="28" icon="ion:warning" width="28" />
        <p>Warning!</p>
        <Icon height="28" icon="ion:warning" width="28" />
      </header>

      <div className="dialog-content">
        {renderContent()}

        <div className="buttons">
          <Button
            className="cancel"
            variant="outlined"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>

          <Button
            disabled={isSending}
            variant="contained"
            onClick={createSchedule}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmBroadcastDialog;
